<template>
  <div class="kpt-detail-field-2">
    <span class="kpt-detail-field-label has-text-black-ter has-text-weight-semibold">
      <slot name="label"></slot>
      <span class="kpt-detail-field-line"></span>
    </span>
    <span class="kpt-detail-field-value">
      <slot name="value"></slot>
    </span>
  </div>
</template>
<script>
export default {
  name: 'DetailField',
  props: {
    labelWidth: {
      type: String,
      default: '120'
    }
  }
}
</script>
<style lang="scss" scoped>
.kpt-detail-field-2 {
  display: grid;
  grid-template-columns: minmax(150px, 200px) auto;
  width: 100%;
  align-content: center;

  .kpt-detail-field-label {
    display: flex;
    justify-content: space-between;
    margin-right: 5px;
  }
  .kpt-detail-field-line {
    border-bottom: 2px #eaeaea solid;
    flex: 1 0 auto;
    height: 19px;
    margin-left: 10px;
    margin-right: 4px;
  }
  .kpt-detail-field-value {

  }
}
</style>
